<template lang="pug">
  v-row
    v-col(cols=12)
      button-toggle-white-ball(
        v-model="whiteBallSelect"
        ref="whiteBallRef"
      )
    v-col(cols=12)
      button-toggle-power-ball(
        v-model="powerBallSelect"
        ref="powerBallRef"
      )
    v-footer(
      fixed
      padless 
    ).footerPowerball
      .d-flex.justify-center(style="width:100%;")
        card-power-ball(style="width:100%; max-width: 1440px;").px-sm-16
          v-row(align="center" no-gutters ).justify-center.px-sm-16
            v-col.px-0(style="min-width:350px;")
              v-row(no-gutters align="center" justify="center")
                v-col(cols="auto")
                  winnumber(
                    :win-number-array="userSelect"
                  )
                //- v-col(cols="auto").px-3
                //-   v-row(align="center" justify="center").ml-5
                //-     h2.white--text( 
                //-       style="font-size: min(4vw,22px) !important;"
                //-     ) {{ sumPrice }} 
                //-     h3.white--text.ml-2( 
                //-       style="font-size: min(4vw,20px) !important;"
                //-     ) {{ $t('unit.credit') }}
            v-col(align="center").pt-2
              dialog-order(
                ref="dialogOrderRef"
                :items="userSelectItems"
                :setSumPrice="setSumPrice"
                :sum-price="sumPrice"
                :price-stake="priceStake"
                :price-stake-power-play="priceStakePowerPlay"
                :click-btn-remove="clickBtnRemove"
                @submit="submit")
              button-buy-ticket(
                :content="userSelectItems.length"
                @click="$refs.dialogOrderRef.open()"
              )
              br
              .white--text.font-weight-power-ball(
                style="font-size: min(2vw,12px) !important; display: inline-flex;"
                v-html="$t('power-ball.message-before-stake')"
              ).mt-3
</template>
<script>
import ButtonBuyTicket from './ButtonBuyTicket'
import ButtonToggleWhiteBall from './ButtonToggleWhiteBall'
import ButtonTogglePowerBall from './ButtonTogglePowerBall'
import CardPowerBall from './CardBasePowerBall.vue'
import DialogOrder from './DialogOrder'
import Winnumber from './Winnumber'
import { powerBall as apiPowerball } from '@/apis'
import { changeNumbertoString } from '@/plugins/helper'
export default {
  components: {
    ButtonBuyTicket,
    ButtonToggleWhiteBall,
    CardPowerBall,
    DialogOrder,
    ButtonTogglePowerBall,
    Winnumber
  },
  props: {
    priceStake: {
      type: String,
      default: null 
    },
    priceStakePowerPlay: {
      type: [String,Number],
      default: null 
    },
    uuid: {
      type: String,
      default: null
    }
  },
  data: () => ({
    whiteBallSelect: [],
    powerBallSelect:null,
    userSelect: [],
    userSelectItems: [], 
    sumPrice: 0,
  }), 
  watch: { 
    powerBallSelect () {
      this.setUserSelect()
    },
    whiteBallSelect () {
      this.setUserSelect()
    },
  },
  methods: {
    setSumPrice () { 
      const reducer = (accumulator, currentValue) => parseFloat(accumulator) + currentValue;
      const price = this.userSelectItems.map(x=>{ 
        if(x.powerPlay && this.priceStakePowerPlay) {
          return parseFloat(this.priceStakePowerPlay) + parseFloat(this.priceStake)
        }
        return parseFloat(this.priceStake)
      }).reduce(reducer,0)
      this.sumPrice = price
    },
    setUserSelect () {
      const items = [...this.whiteBallSelect]
      if(this.powerBallSelect) {
        items[5] = this.powerBallSelect 
      }
      this.userSelect = items
      if(items.filter(x=>x !== null).length >= 6) {
        this.resetStakePanel()
        this.addValue(items.map(x=>{
          if(x) return changeNumbertoString(x, 2)
        }))
      }
    },
    addValue (val) { 
      this.userSelectItems.push({
        winNumberArray: val,
        powerPlay: false 
      })
      this.setSumPrice()
    },
    resetStakePanel () {
      this.userSelect = []
      this.$refs.whiteBallRef.clear()
      this.$refs.powerBallRef.clear() 
    },
    clickBtnRemove (index) {
      if(this.userSelectItems.length === 0) return
      this.userSelectItems.splice(index,1)
      this.setSumPrice()
    },
    async submit () {
      const params = {
        stakes : this.userSelectItems.map(x=>{
          return {
            'white_ball': x.winNumberArray.slice(0,5),
            'power_ball': x.winNumberArray[5],
            'power_play': x.powerPlay
          }
        })
      }
      const [err, , message] = await apiPowerball.stake(this.uuid, params)
      if(err) { 
        this.$alert('',err,'warning')  
        return
      }
      //reset
      this.resetStakePanel()
      this.userSelectItems = []
      this.setSumPrice()
      this.$alert('',message,'success')
      setTimeout(() => {
        this.$emit('success')
      }, 1000);
    }
  }
}
</script>
<style scoped>
@media only screen and (min-width: 960px) { 
  .columnWinnumber {
    min-width:300px !important;
  }
}
@media only screen and (max-width: 960px) { 
  .footerPowerball {
    width: 100% !important;
  }
}
.footerPowerball { 
  padding: 10px 20px;
  position:fixed;
  width: calc(100% - 46px);
  left: auto !important;
  right: 0;
  background:inherit;
}
</style>